
const storeProjectId: string | null = localStorage.getItem('projectId');


export const initialValuesPermit={
    projectId: storeProjectId,
    projPermitResult: [
      {
        projectId:storeProjectId ,
        surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: "",
        surveyResultOriginal: "",
        fieldType: "",
        sectionId: 0,
        subSectionId: 0,
        lst_CreatedBy: {
          id: 0,
          value: ""
        },
        lst_ModifiedBy: {
          id: 0,
          value: ""
        },
        createdDT:"2024-12-03T07:57:44.259Z",
        modifiedDT: "2024-12-03T07:57:44.259Z"
      }
    ]
  }

   export const initialValuesSpecException = {
          id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
          projectId: storeProjectId,
          lst_ExceptionType: {
              id: 0,
              value: ""
          },
          lst_ExceptionCategory: {
              id: 0,
              value: ""
          },
          amountImpacted: false,
          scopeImpacted: false,
          timelineImpacted: false,
          notes: ""
      }